/*
 * @Descripttion: 
 * @version: 
 * @Author: ankeji
 * @Date: 2024-04-26 15:48:49
 * @LastEditors: ankeji
 * @LastEditTime: 2025-10-25 23:04:53
 */
import axios from "axios";
import {
  ElMessage
} from "element-plus";


const service = axios.create({
  // baseURL: '/api',
  timeout: 50000,
  withCredentials: true
});

// Request interceptors
service.interceptors.request.use(
  (config) => {
    // if (token && sign) {
    //   config.headers['Authorization'] = `Bearer ${token}`; // 将 token 添加到请求头
    //   config.headers['sign'] = `${sign}`; // 将 sign 添加到请求头
    // }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// Response interceptors
service.interceptors.response.use(
  (response) => {
    if (response.status !== 200) {
      ElMessage({
        type: "error",
        message: response?.data?.error || "服务器忙,请稍后再试~",
      });
      return;
    }

    return response;
  },
  (error) => {
    // do something
    ElMessage({
      type: "error",
      message: error || "服务器忙,请稍后再试~",
    });
    return Promise.reject(error);
  }
);

export default service;